export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
  imageSeq: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Verified sneaker drops',
    imageSeq: 'cat-shoes-2026',
    imageQuery: 'Minimalist%20sneaker%20display%20on%20clean%20white%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20with%20warm%20cream%20background%2C%20elegant%20composition%2C%20high%20detail%2C%20lifestyle%20aesthetic%2C%20neutral%20tones%2C%20modern%20minimal%20style%2C%20shallow%20depth%20of%20field%2C%20premium%20quality%20texture%20visible',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy streetwear picks',
    imageSeq: 'cat-hoodies-2026',
    imageQuery: 'Premium%20hoodie%20flat%20lay%20on%20cream%20linen%20texture%2C%20soft%20morning%20light%2C%20editorial%20fashion%20photography%2C%20minimal%20aesthetic%2C%20warm%20neutral%20palette%2C%20high%20fabric%20detail%20visible%2C%20elegant%20composition%2C%20modern%20streetwear%20style%2C%20subtle%20textures',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Essential basics collection',
    imageSeq: 'cat-tshirts-2026',
    imageQuery: 'Premium%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20beige%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20product%20photography%2C%20clean%20editorial%20style%2C%20neutral%20cream%20background%2C%20fabric%20texture%20detail%2C%20elegant%20simplicity%2C%20modern%20fashion%20aesthetic',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Premium outerwear finds',
    imageSeq: 'cat-jackets-2026',
    imageQuery: 'Stylish%20jacket%20draped%20on%20minimal%20wooden%20hanger%2C%20warm%20ambient%20lighting%2C%20cream%20wall%20background%2C%20editorial%20fashion%20photography%2C%20premium%20fabric%20texture%2C%20elegant%20minimal%20composition%2C%20neutral%20earthy%20tones%2C%20sophisticated%20aesthetic',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Everyday comfort wear',
    imageSeq: 'cat-pants-2026',
    imageQuery: 'Casual%20trousers%20flat%20lay%20on%20light%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20clean%20editorial%20style%2C%20neutral%20warm%20tones%2C%20fabric%20detail%20visible%2C%20modern%20fashion%20aesthetic%2C%20simple%20elegant%20composition',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps & beanies',
    imageSeq: 'cat-headwear-2026',
    imageQuery: 'Premium%20baseball%20cap%20on%20minimal%20display%20stand%2C%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20earth%20tones%2C%20texture%20detail%2C%20modern%20minimal%20style',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Coordinated outfit bundles',
    imageSeq: 'cat-sets-2026',
    imageQuery: 'Matching%20clothing%20set%20flat%20lay%20arrangement%20on%20cream%20linen%2C%20soft%20daylight%2C%20editorial%20fashion%20photography%2C%20minimal%20aesthetic%2C%20warm%20neutral%20palette%2C%20coordinated%20colors%2C%20elegant%20composition%2C%20premium%20fabric%20textures',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Comfort essentials',
    imageSeq: 'cat-underwear-2026',
    imageQuery: 'Soft%20cotton%20underwear%20neatly%20arranged%20on%20warm%20beige%20surface%2C%20gentle%20natural%20lighting%2C%20clean%20minimal%20product%20photography%2C%20neutral%20cream%20background%2C%20subtle%20textures%2C%20elegant%20simplicity%2C%20modern%20lifestyle%20aesthetic',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports & team wear',
    imageSeq: 'cat-jersey-2026',
    imageQuery: 'Athletic%20jersey%20flat%20lay%20on%20light%20cream%20surface%2C%20soft%20studio%20lighting%2C%20minimal%20sports%20product%20photography%2C%20clean%20editorial%20style%2C%20neutral%20warm%20tones%2C%20fabric%20detail%2C%20modern%20athletic%20aesthetic',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Finishing touch pieces',
    imageSeq: 'cat-accessories-2026',
    imageQuery: 'Fashion%20accessories%20artfully%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20minimal%20aesthetic%2C%20neutral%20earthy%20tones%2C%20elegant%20composition%2C%20lifestyle%20styling%2C%20high%20detail',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks & totes',
    imageSeq: 'cat-bags-2026',
    imageQuery: 'Premium%20leather%20bag%20on%20minimal%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20texture%20detail%2C%20modern%20minimal%20style%2C%20sophisticated%20composition',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather & casual styles',
    imageSeq: 'cat-belts-2026',
    imageQuery: 'Elegant%20leather%20belt%20coiled%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20clean%20editorial%20style%2C%20neutral%20cream%20background%2C%20leather%20texture%20detail%2C%20modern%20accessories%20aesthetic',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragrance collection',
    imageSeq: 'cat-perfumes-2026',
    imageQuery: 'Elegant%20perfume%20bottle%20on%20minimal%20cream%20surface%2C%20soft%20warm%20lighting%2C%20editorial%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20earthy%20tones%2C%20glass%20reflection%20detail%2C%20modern%20luxury%20style%2C%20sophisticated%20composition',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'More hidden gems',
    imageSeq: 'cat-other-2026',
    imageQuery: 'Curated%20miscellaneous%20lifestyle%20products%20artfully%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20minimal%20aesthetic%2C%20neutral%20earthy%20tones%2C%20elegant%20composition%2C%20modern%20lifestyle%20style',
  },
];